import { createReducer, createActions } from 'reduxsauce'

export const Connector = "News_1";

export const { Types, Creators } = createActions({
  getSuccess: ['data'],
  getRequest: ['payload'],
  clearRequest: [],
}, {
  prefix: "@Notice/"
})

const INITIAL_STATE = {
  loading: false,
  success: false,
  error: false,
  data: []
}

const getNoticeRequest = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
  success: false
})

const getNoticeSuccess = (state = INITIAL_STATE, { data : {  data } }) => ({
  ...state,
  data,
  loading: false,
  success: true,
})

const clearRequest = (state = INITIAL_STATE) => ({
  ...state,
  data: [],
  loading: false,
  success: false,
})

export default createReducer(INITIAL_STATE, {
  [Types.GET_REQUEST]: getNoticeRequest,
  [Types.GET_SUCCESS]: getNoticeSuccess,
  [Types.CLEAR_REQUEST]: clearRequest,
})